import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export const Logo = ({ className, testId = "logo-link" }) => (
  <Link to="/" aria-label="Nivo Garage – Startseite" data-testid={testId} className={cn("inline-flex items-center gap-2.5 group", className)}>
    <img src="/nivo-mark.png" alt="" width="527" height="242" className="h-[30px] md:h-[36px] w-auto" />
    <span className="text-[18px] md:text-[20px] font-semibold tracking-[-0.01em] text-[color:var(--ink)] leading-none">Nivo Garage</span>
  </Link>
);
